
import { PuttSituation } from "@/types/golf";
import ApproachCard from "./ApproachCard";
import { liftedApproaches } from "@/data/approaches/liftedApproaches";
import { longChips } from "@/data/approaches/longChips";
import { shortChips } from "@/data/approaches/shortChips";
import { wedging50m } from "@/data/approaches/wedging50m";
import { wedging30m } from "@/data/approaches/wedging30m";
import { shortBunker } from "@/data/approaches/shortBunker";
import { longBunker } from "@/data/approaches/longBunker";
import { midDistanceApproaches } from "@/data/approaches/midDistanceApproaches";
import { roughApproaches } from "@/data/approaches/roughApproaches";

interface ApproachCardGridProps {
  onSelectTest: (test: PuttSituation) => void;
  refreshAfterToast?: () => void;
}

const ApproachCardGrid = ({ onSelectTest, refreshAfterToast }: ApproachCardGridProps) => {
  const approaches = [
    liftedApproaches,
    longChips,
    shortChips,
    wedging50m,
    wedging30m,
    shortBunker,
    longBunker,
    midDistanceApproaches,
    roughApproaches
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {approaches.map((approach, index) => (
        <ApproachCard 
          key={approach.id} 
          approach={approach} 
          index={index}
          onSelectTest={onSelectTest}
          refreshAfterToast={refreshAfterToast}
        />
      ))}
    </div>
  );
};

export default ApproachCardGrid;
